<template>
  <div class="modal nb-modal-mask" style="display:block" @keyup.esc="closeModal()">
    <!-- <div class="modal-body" style="height: 180px!important ;max-height: 100%; overflow-y: auto">
          <div class="d-flex w-100 mb-3">
            <span style="font-size: 20px">
              <strong>
                Processando nota fiscal
              </strong>
            </span>
            <button type="button" class="close" @click="closeModal()" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div> -->
    <div
      class="modal-dialog modal-dialog-centered modal-xl"
      role="document"
      style="overflow-y: initial !important; margin: 5px auto;"
    >
      <div class="modal-content modal-full-h">
        <div class="modal-header" style="background: '#174b79' !important;">
          <div class="d-flex w-100 justify-content-center">
              <div v-for="(step, index) in steps" :key="index" class="d-flex">
                <div class="step-wrapper">
                  <div :class="['circle', { active: index === localStep }]">
                    {{ index + 1 }}
                  </div>
                  <!-- <div class="label">{{ step }}</div> -->
                </div>
                <div v-if="index < steps.length - 1" class="line"></div>
              </div>
            </div>
          <!-- <h4
            class="def-title"
            style="background: '#174b79' !important;"
            id="exampleModalLabel"
          >
            Configuração da Empresa
          </h4>
          <button
            @click="closeModal()"
            style="background: 'white' !important;"
            class="close"
          >
            <span>&times;</span>
          </button> -->
        </div>
        <div
          class="modal-body"
          style="height: 180px!important; max-height: 100%; overflow-y: auto"
        >
          <FilialForm
            :guide="this.guide"
            ref="filialFormRef"
            :type="guideType"
            @gonextstep="nextStep"
          />
        </div>
        <div
          class="modal-footer d-flex justify-content-center"
          style="width: 100%;"
        >
          <v-button class="ml-3" style="position: absolute; left: 0;" label="Continuar Depois" ref="qtdConfirmButton" @click="closeModal()"/>
          <v-button
            nbBtdef
            label="Anterior"
            ref="qtdConfirmButton"
            @click="backStep()"
            v-if="canGoBack"
          />
          <v-button
            nbBtdef
            label="Salvar"
            ref="qtdConfirmButton"
            @click="handleSave()"
            v-if="lastStep"
          />
          <v-button
            nbBtdef
            :label="this.guide ? 'Próximo' : 'Confirmar'"
            ref="qtdConfirmButton"
            @click="tryNextStep()"
            v-else
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FilialForm from "../forms/filial-form";

export default {
  components: {
    FilialForm
  },
  props: {},
  data() {
    return {
      guide: true,
      localStep: 0,
      lastStep: false,
      guideType: "NFE",
      steps: ["1", "2", "3", "4"]
    };
  },
  methods: {
    changeToNextEl() {
      this.$nextTick(function() {
        this.$refs.qtdConfirmButton.focus();
      });
    },

    closeModal() {
      this.$router.go(-1)
    },

    tryNextStep() {
      if (this.$refs.filialFormRef.tabCertificado) 
        this.nextStep();
      else if (this.$refs.filialFormRef.tabDados)
        this.$refs.filialFormRef.handleSave();
      else 
        this.$refs.filialFormRef.handleSave(true);
    },

    nextStep() {
      if (
        this.$refs.filialFormRef.activeTab ===
        this.$refs.filialFormRef.tabLength - 1
      )
        return;
      this.$refs.filialFormRef.activeTab += 1;
      this.localStep = this.$refs.filialFormRef.activeTab;
      if (
        this.$refs.filialFormRef.activeTab ===
        this.$refs.filialFormRef.tabLength - 1
      ) {
        this.lastStep = true;
      }
      // console.log(this.$refs.filialFormRef.filteredTabs);
    },
    backStep() {
      this.lastStep = false;
      this.$refs.filialFormRef.activeTab -= 1;
      this.localStep = this.$refs.filialFormRef.activeTab;
    },
    handleSave() {
      this.$refs.filialFormRef.handleSave();
      this.closeModal();
    }
  },
  computed: {
    canGoBack() {
      return this.localStep >= 1;
    }
  },

  created() {
    if (this.$route.params.param == "pdv") {
      this.guideType = "PDV";
      this.steps = ["1", "2", "3"]
    }
  },

  mounted() {}
};
</script>

<style>
.step-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.circle {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: #ccc;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}

.circle.active {
  background-color: #174b79;
}

.line {
  width: 18rem;
  height: 4px;
  background-color: #ccc;
  margin: 13px 5px 0 5px;
}

.label {
  margin-top: 6px;
  font-size: 0.75rem;
  text-align: center;
  color: #555;
  max-width: 60px;
}
</style>



// WEBPACK FOOTER //
// src/forms/config-guia.vue